import { SITES } from '../../../constants';

export const initialState = {
  displayType: SITES.STATES.HOME,
  searchParams: {
    name: '',
    siteNumber: '',
    siteType: 0,
    active: 'y',
    corporateCustomer: 0,
    billToCustomer: 0,
    voyix_Owned: 'a',
  },
  customerDetails: null,
  siteDetails: null,
  siteDetailsCopy: null,
  searchResult: null,
  selectedSite: null,
  payloadCustId:0,
  siteAccountDetailData: null,
  back:false,
  localSearchText:'',
  fastSite:false,
  localSelectedComp:'',
  oldSiteOption: '',
  isSiteOptionChanged: false,
  siteDataSavedFlag: false
  //,newSiteOption:''
};
